/**
 * 公共 | 黑名单 | 工人 | 导出 | 微信平台 | 通知
 */
import Net from '../net';

const NAME = '[CommonApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === Common === **/
/** common/get-third-token
 * @param {Object} data
*/
export async function getCommonThirdToken(data = {}) {
  Log('getCommonThirdToken data:', data)
  try {
    const res = await Net.http('common/get-third-token', { data, roleMark: '' })
    Log('getCommonThirdToken res:', res)
    return res
  } catch (err) {
    Log('getCommonThirdToken err:', err)
    throw err
  }
}

/** client/1/common/phone-verification-code-send
 * @param {Object} data
 * @param {*} data.phone
*/
export async function commonCodeSend(data = {}) {
  Log('commonCodeSend data:', data)
  try {
    const res = await Net.http('client/1/common/phone-verification-code-send', { data, roleMark: '' })
    Log('commonCodeSend res:', res)
    return res
  } catch (err) {
    Log('commonCodeSend err:', err)
    throw err
  }
}

/** client/1/common/phone-verification-code-check
 * @param {Object} data
 * @param {*} data.phone
 * @param {*} data.code
*/
export async function commonCodeCheck(data = {}) {
  Log('commonCodeCheck data:', data)
  try {
    const res = await Net.http('client/1/common/phone-verification-code-check', { data, roleMark: '' })
    Log('commonCodeCheck res:', res)
    return res
  } catch (err) {
    Log('commonCodeCheck err:', err)
    throw err
  }
}


/** === BlackPanel === **/
/** black-panel/save
 * @param {Object} data
 * @param {*} data.user_type
 * @param {*} data.type
 * @param {*} data.operator_id
*/
export async function saveBlackPanel(data = {}) {
  Log('saveBlackPanel data:', data)
  try {
    const res = await Net.http('black-panel/save', { data })
    Log('saveBlackPanel res:', res)
    return res
  } catch (err) {
    Log('saveBlackPanel err:', err)
    throw err
  }
}

/** black-panel/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.user_type
 * @param {*} data.type
 * @param {*} data.operator_id
*/
export async function getBlackPanelList(data = {}) {
  Log('getBlackPanelList data:', data)
  try {
    const res = await Net.http('black-panel/list', { data })
    Log('getBlackPanelList res:', res)
    return res
  } catch (err) {
    Log('getBlackPanelList err:', err)
    throw err
  }
}

/** black-panel/delete
 * @param {Object} data
 * @param {*} data.black_panel_id
*/
export async function deleteBlackPanel(data = {}) {
  Log('deleteBlackPanel data:', data)
  try {
    const res = await Net.http('black-panel/delete', { data })
    Log('deleteBlackPanel res:', res)
    return res
  } catch (err) {
    Log('deleteBlackPanel err:', err)
    throw err
  }
}

/** black-panel/delete-batch
 * @param {Object} data
 * @param {*} data.black_panel_ids
*/
export async function batchDeleteBlackPanel(data = {}) {
  Log('batchDeleteBlackPanel data:', data)
  try {
    const res = await Net.http('black-panel/delete-batch', { data })
    Log('batchDeleteBlackPanel res:', res)
    return res
  } catch (err) {
    Log('batchDeleteBlackPanel err:', err)
    throw err
  }
}

/** black-panel/find-black-panel-by-operator
 * @param {Object} data
 * @param {*} data.user_type
 * @param {*} data.type
 * @param {*} data.operator_id
*/
export async function blackPanelFindbBlackPanelByOperator(data = {}) {
  Log('blackPanelFindbBlackPanelByOperator data:', data)
  try {
    const res = await Net.http('black-panel/find-black-panel-by-operator', { data })
    Log('blackPanelFindbBlackPanelByOperator res:', res)
    return res
  } catch (err) {
    Log('blackPanelFindbBlackPanelByOperator err:', err)
    throw err
  }
}

/** black-panel/create
 * @param {Object} data
 * @param {*} data.user_type
 * @param {*} data.type
 * @param {*} data.operator_id
 * @param {*} data.orgId
 * @param {*} data.user_phone
 * @param {*} data.username
*/
export async function createBlackPanel(data = {}) {
  Log('createBlackPanel data:', data)
  try {
    const res = await Net.http('black-panel/create', { data })
    Log('createBlackPanel res:', res)
    return res
  } catch (err) {
    Log('createBlackPanel err:', err)
    throw err
  }
}

/** black-panel/update
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.username
*/
export async function updateBlackPanel(data = {}) {
  Log('updateBlackPanel data:', data)
  try {
    const res = await Net.http('black-panel/update', { data })
    Log('updateBlackPanel res:', res)
    return res
  } catch (err) {
    Log('updateBlackPanel err:', err)
    throw err
  }
}

/** black-panel/action-list
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.user_id
 * @param {*} data.page
*/
export async function blackPanelActionList(data = {}) {
  Log('blackPanelActionList data:', data)
  try {
    const res = await Net.http('black-panel/action-list', { data })
    Log('blackPanelActionList res:', res)
    return res
  } catch (err) {
    Log('blackPanelActionList err:', err)
    throw err
  }
}


/** === Worker === **/
/** worker/list
 * @param {Object} data
 * @param {*} data.username
 * @param {*} data.page
*/
export async function getWorkerList(data = {}) {
  Log('getWorkerList data:', data)
  try {
    const res = await Net.http('worker/list', { data })
    Log('getWorkerList res:', res)
    return res
  } catch (err) {
    Log('getWorkerList err:', err)
    throw err
  }
}

/** worker/save
 * @param {Object} data
 * @param {*} data.username
 * @param {*} data.password
 * @param {*} data.content
*/
export async function saveWorker(data = {}) {
  Log('saveWorker data:', data)
  try {
    const res = await Net.http('worker/save', { data })
    Log('saveWorker res:', res)
    return res
  } catch (err) {
    Log('saveWorker err:', err)
    throw err
  }
}

/** worker/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteWorker(data = {}) {
  Log('deleteWorker data:', data)
  try {
    const res = await Net.http('worker/delete', { data })
    Log('deleteWorker res:', res)
    return res
  } catch (err) {
    Log('deleteWorker err:', err)
    throw err
  }
}


/** === Export === **/
/** device/export-device-list
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.station_id
 * @param {*} data.gateway_id
 * @param {*} data.uid
 * @param {*} data.suid
*/
export async function getDeviceExport(data = {}) {
  Log('getDeviceExport data:', data)
  try {
    const res = await Net.http('device/export-device-list', { data })
    Log('getDeviceExport res:', res)
    return res
  } catch (err) {
    Log('getDeviceExport err:', err)
    throw err
  }
}

/** export-task/create-order-export
 * @param {Object} data
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.status
 * @param {*} data.clearing_status
 * @param {*} data.pay_method
 * @param {*} data.finish_code
 * @param {*} data.alipay_shualan_type
 * @param {*} data.gateway_uid
 * @param {*} data.user_name
 * @param {*} data.user_phone
 * @param {*} data.device_type
 * @param {*} data.socket_uid
 * @param {*} data.outer_sn
 * @param {*} data.finish_begin_time
 * @param {*} data.finish_end_time
 * @param {*} data.clearing_begin_time
 * @param {*} data.clearing_end_time
 * @param {*} data.flag_vip
*/
export async function exportCharging(data = {}) {
  Log('exportCharging data:', data)
  try {
    const res = await Net.http('export-task/create-order-export', { data })
    Log('exportCharging res:', res)
    return res
  } catch (err) {
    Log('exportCharging err:', err)
    throw err
  }
}

/** export-task/create-charge-order-export
 * @param {Object} data
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.refund_begin_time
 * @param {*} data.refund_end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.status
 * @param {*} data.pay_method
 * @param {*} data.clearing_status
 * @param {*} data.user_name
 * @param {*} data.card_uid
 * @param {*} data.user_phone
 * @param {*} data.charge_type
 * @param {*} data.flag_vip
*/
export async function exportRecharge(data = {}) {
  Log('exportRecharge data:', data)
  try {
    const res = await Net.http('export-task/create-charge-order-export', { data })
    Log('exportRecharge res:', res)
    return res
  } catch (err) {
    Log('exportRecharge err:', err)
    throw err
  }
}

/** insurance/export
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function exportInsurance(data = {}) {
  Log('exportInsurance data:', data)
  try {
    const res = await Net.http('insurance/export', { data })
    Log('exportInsurance res:', res)
    return res
  } catch (err) {
    Log('exportInsurance err:', err)
    throw err
  }
}

/** insurance/export-operator
 * @param {Object} data
 * @param {*} data.page
*/
export async function exportVenueInsurance(data = {}) {
  Log('exportVenueInsurance data:', data)
  try {
    const res = await Net.http('insurance/export-operator', { data })
    Log('exportVenueInsurance res:', res)
    return res
  } catch (err) {
    Log('exportVenueInsurance err:', err)
    throw err
  }
}

/** export-task/create-statement-export
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.type
 * @param {*} data.flag_vip
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function exportStatement(data = {}) {
  Log('exportStatement data:', data)
  try {
    const res = await Net.http('export-task/create-statement-export', { data })
    Log('exportStatement res:', res)
    return res
  } catch (err) {
    Log('exportStatement err:', err)
    throw err
  }
}


/** === ExportTask === **/
/** export-task/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.types
 * @param {*} data.status
*/
export async function getExportTaskList(data = {}) {
  Log('getExportTaskList data:', data)
  try {
    const res = await Net.http('export-task/list', { data })
    Log('getExportTaskList res:', res)
    return res
  } catch (err) {
    Log('getExportTaskList err:', err)
    throw err
  }
}

/** export-task/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteExportTask(data = {}) {
  Log('deleteExportTask data:', data)
  try {
    const res = await Net.http('export-task/delete', { data })
    Log('deleteExportTask res:', res)
    return res
  } catch (err) {
    Log('deleteExportTask err:', err)
    throw err
  }
}


/** === WxPlatform === **/
/** wax/get-pre-code
 * @param {Object} data
*/
export async function getWxPlatformCode(data = {}) {
  Log('getWxPlatformCode data:', data)
  try {
    const res = await Net.http('wax/get-pre-code', { data })
    Log('getWxPlatformCode res:', res)
    return res
  } catch (err) {
    Log('getWxPlatformCode err:', err)
    throw err
  }
}

/** wax/commit
 * @param {Object} data
 * @param {*} data.appid
 * @param {*} data.user_version
 * @param {*} data.user_desc
 * @param {*} data.template_id
 * @param {*} data.ext_json
*/
export async function wxPlatformCommit(data = {}) {
  Log('wxPlatformCommit data:', data)
  try {
    const res = await Net.http('wax/commit', { data })
    Log('wxPlatformCommit res:', res)
    return res
  } catch (err) {
    Log('wxPlatformCommit err:', err)
    throw err
  }
}

/** wax/submit
 * @param {Object} data
 * @param {*} data.appid
*/
export async function wxPlatformSubmit(data = {}) {
  Log('wxPlatformSubmit data:', data)
  try {
    const res = await Net.http('wax/submit', { data })
    Log('wxPlatformSubmit res:', res)
    return res
  } catch (err) {
    Log('wxPlatformSubmit err:', err)
    throw err
  }
}

/** wax/get-try-qr-code
 * @param {Object} data
 * @param {*} data.appid
*/
export async function wxPlatformQrCode(data = {}) {
  Log('wxPlatformQrCode data:', data)
  try {
    const res = await Net.http('wax/get-try-qr-code', { data })
    Log('wxPlatformQrCode res:', res)
    return res
  } catch (err) {
    Log('wxPlatformQrCode err:', err)
    throw err
  }
}

/** wax/query-last-audit-status
 * @param {Object} data
 * @param {*} data.appid
*/
export async function checkWxPlatform(data = {}) {
  Log('checkWxPlatform data:', data)
  try {
    const res = await Net.http('wax/query-last-audit-status', { data })
    Log('checkWxPlatform res:', res)
    return res
  } catch (err) {
    Log('checkWxPlatform err:', err)
    throw err
  }
}

/** wax/release
 * @param {Object} data
 * @param {*} data.appid
*/
export async function wxPlatformRelease(data = {}) {
  Log('wxPlatformRelease data:', data)
  try {
    const res = await Net.http('wax/release', { data })
    Log('wxPlatformRelease res:', res)
    return res
  } catch (err) {
    Log('wxPlatformRelease err:', err)
    throw err
  }
}

/** wax/set-privacy-setting
 * @param {Object} data
 * @param {*} data.appid
 * @param {*} data.privacy_ver
 * @param {*} data.owner_setting
 * @param {*} data.setting_list
*/
export async function setWxPlatformPrivacy(data = {}) {
  Log('setWxPlatformPrivacy data:', data)
  try {
    const res = await Net.http('wax/set-privacy-setting', { data })
    Log('setWxPlatformPrivacy res:', res)
    return res
  } catch (err) {
    Log('setWxPlatformPrivacy err:', err)
    throw err
  }
}

/** wax/get-privacy-setting
 * @param {Object} data
 * @param {*} data.appid
 * @param {*} data.privacy_ver
*/
export async function getWxPlatformPrivacy(data = {}) {
  Log('getWxPlatformPrivacy data:', data)
  try {
    const res = await Net.http('wax/get-privacy-setting', { data })
    Log('getWxPlatformPrivacy res:', res)
    return res
  } catch (err) {
    Log('getWxPlatformPrivacy err:', err)
    throw err
  }
}


/** === Notify === **/
/** notify
 * @param {Object} data
 * @param {*} data.auth_code
 * @param {*} data.expires_in
*/
export async function notifyNotify(data = {}) {
  Log('notifyNotify data:', data)
  try {
    const res = await Net.http('notify', { data, roleMark: '' })
    Log('notifyNotify res:', res)
    return res
  } catch (err) {
    Log('notifyNotify err:', err)
    throw err
  }
}
